import { format, subDays, subMonths, addMonths, addDays, startOfMonth, endOfMonth } from 'date-fns'
import DefaultForm from '@/utils/defaultForm'
import { formatInTimeZone } from 'date-fns-tz'
import { sortItems, downloadFile } from '@/utils/genericUtils'
import { Ventas } from '../..//models/venta'
import request from '@/utils/request'
import { buildObtenerProductoParams } from '@/utils/productoParams'
import { montoParaGuardar, normalizarComprobante } from '@/utils/montos'

// ============================================================
// Filtro de estados por rol — fuente única de verdad
// Antes era una whitelist hardcodeada duplicada en getReservas y
// getReservasV2: cada estado nuevo agregado en tb_estados quedaba
// oculto para los usuarios hasta editar el frontend (p. ej. los
// estados 44 SOLICITANDO COTIZACION y 45 PENDIENTE FIRMA).
// Ahora:
//  - permitidos: whitelist (solo esos estados)
//  - excluidos:  blacklist (todo EXCEPTO esos estados)
//  - null:       sin filtro, ve todos (incluidos los futuros)
// ============================================================
const FILTROS_ROL = {
    // VENDEDOR — ve todos los estados
    6: { nombre: 'VENDEDOR', permitidos: null, validarFinalizado: false },
    // ADMINISTRADOR — ve todos los estados
    2: { nombre: 'ADMINISTRADOR', permitidos: null, validarFinalizado: false },
    // SUPER USER — ve todo sin restricciones
    3: { nombre: 'SUPER USER', permitidos: null, validarFinalizado: false },
    // LOGISTICA — ve producción/logística, excluye terminales y pre-venta:
    // 9 ENTREGADO, 10 RECHAZADO, 11 ANULADO, 15 ENTREGA PARCIAL,
    // 18 CARTERA CASTIGADA, 34 FINALIZADO, 39 ENVIADO COBRANZA,
    // 42 PAGADO, 44 SOLICITANDO COTIZACION, 45 PENDIENTE FIRMA
    4: {
        nombre: 'LOGISTICA',
        excluidos: [9, 10, 11, 15, 18, 34, 39, 42, 44, 45],
        validarFinalizado: true
    },
    // REPARTO — solo PROGRAMADO (7) y EN CAMINO (8)
    5: { nombre: 'REPARTO', permitidos: [7, 8], validarFinalizado: true }
}

const pasarFiltroRol = (venta, configuracionRol) => {
    const idEstado = Number(venta.idEstado)

    if (configuracionRol.permitidos) {
        if (!configuracionRol.permitidos.includes(idEstado)) {
            return false
        }
    } else if (configuracionRol.excluidos) {
        if (configuracionRol.excluidos.includes(idEstado)) {
            return false
        }
    }

    if (configuracionRol.validarFinalizado && venta.finalizado === 1) {
        return false
    }

    return true
}

/* ## callback venta ## */
const state = {
    datos: DefaultForm.formDefault(),
    modalReserva: {
        step: 1, // default 1
        state: false, // false Default,
        showItem: false
    },
    modalHistorialEstado: {
        state: false,
        idVenta: null
    },
    modalDatosEnvio: { state: false },
    listCodeBar: {},
    mixtos: [],
    privados: [],
    masajes: [],
    dataVenta: [],
    productos: [],
    idVenta: {},
    servicios: [],
    cortesia: [],
    mixtosToday: [],
    privadosToday: [],
    productosToday: [],
    masajesToday: [],
    loadingReservas: false,
    listaVentas: [],
    listaVentaHisto: [],
    listaCalendarioToday: [],
    ticketChangeHistory: [],
    listaEntregas: [],
    proximasEntregas: [],
    loadingProximasEntregas: false,
    proximasEntregasLastFetch: 0
}

const getters = {
    getListaVentas: (state) => {
        return sortItems(state.listaVentas, 'id', 1)
    },
    // items: [
    //     { id: 12, text: 'Privado' },
    //     { id: 11, text: 'Masaje' },
    //     { id: 10, text: 'Mixto' }
    // ],
    listaItemMixto: (state) => {
        let lista = []
        state.listaCalendarioToday.map((x) => {
            const newList = x.privados ? x.privados : []

            const item = newList.filter((y) => y.category_id == 10)
            lista = lista.concat(item)
        })
        return lista
    },
    listaItemMasajes: (state) => {
        let lista = []
        state.listaCalendarioToday.map((x) => {
            const newList = x.privados ? x.privados : []

            const item = newList.filter((y) => y.category_id == 11)
            lista = lista.concat(item)
        })
        return lista
    },
    listaItemPrivados: (state) => {
        let lista = []
        state.listaCalendarioToday.map((x) => {
            const newList = x.privados ? x.privados : []

            const item = newList.filter((y) => y.category_id == 12)
            lista = lista.concat(item)
        })
        return lista
    },
    getListaVentaToday: (state) => {
        const today = format(new Date(), 'yyyy-MM-dd')
        return state.listaVentaHisto.filter((x) => x.fechaCreacion == today)
    },

    listServices(state) {
        return state.servicios
    },

    listTicketChangeHistory(state) {
        return state.ticketChangeHistory
    },

    listEntregas(state) {
        return state.listaEntregas
    },

    upcomingDeliveries(state) {
        const hoy = format(new Date(), 'yyyy-MM-dd')
        const manana = format(addDays(new Date(), 1), 'yyyy-MM-dd')
        return state.listaVentaHisto.filter((venta) => {
            return (venta.check_in === hoy || venta.check_in === manana) && venta.idEstado !== 9
        })
    }
}

const mutations = {
    UPDATE_LISTA(state, payload) {
        state.listaVentas = payload
    },

    UPDATE_MYCODEBAR(state, payload) {
        state.listCodeBar = payload
    },
    UPDATE_DATAVENTA(state, payload) {
        state.dataVenta = payload
    },

    UPDATE_MIXTOS(state, payload) {
        state.mixtos = payload
    },
    UPDATE_CORTESIA(state, payload) {
        state.cortesia = payload
    },
    UPDATE_IDVENTA(state, payload) {
        state.idVenta = payload
    },
    UPDATE_PRIVADOS(state, payload) {
        state.privados = payload
    },
    UPDATE_PRODUCTOS(state, payload) {
        state.productos = payload
    },
    UPDATE_MASAJES(state, payload) {
        state.masajes = payload
    },
    UPDATE_MIXTOS_TODAY(state, payload) {
        state.mixtosToday = payload
    },
    UPDATE_PRIVADOS_TODAY(state, payload) {
        state.privadosToday = payload
    },
    UPDATE_PRODUCTOS_TODAY(state, payload) {
        state.productosToday = payload
    },
    UPDATE_MASAJES_TODAY(state, payload) {
        state.masajesToday = payload
    },
    SHOW_MODAL(state, payload) {
        state.modalReserva = payload
    },
    SHOW_MODAL_HISTORIAL_ESTADO(state, payload) {
        if (typeof payload === 'object') {
            state.modalHistorialEstado = payload
        } else {
            state.modalHistorialEstado.state = payload
        }
    },
    SHOW_MODAL_DATOS_ENVIO(state, payload) {
        if (typeof payload === 'object') {
            state.modalDatosEnvio = payload
        } else {
            state.modalDatosEnvio.state = payload
        }
    },
    UPDATE_DATOS(state, payload) {
        console.log('atributos___update ', payload)
        state.datos = { ...state.datos, ...payload }
    },
    UPDATE_LISTA_RESERVAS(state, payload) {
        state.listaVentaHisto = payload
    },
    UPDATE_LISTA_RESERVAS_TODAY(state, payload) {
        state.listaPreReservaToday = payload
    },

    UPDATE_LISTA_RESERVAS_PENDIENTES(state, payload) {
        state.listaCalendarioToday = payload
    },
    UPDATE_LOADING_RESERVAS(state, payload) {
        state.loadingReservas = payload
    },
    RESET_DATOS(state) {
        state.datos = DefaultForm.formDefault()
        state.mixtos = []
        state.privados = []
        state.masajes = []
        state.productos = []
        state.cortesia = []
    },

    UPDATE_TICKET_CHANGE_HISTORY(state, payload) {
        state.ticketChangeHistory = payload
    },

    UPDATE_LISTA_ENTREGAS(state, payload) {
        state.listaEntregas = payload
    },
    UPDATE_PROXIMAS_ENTREGAS(state, payload) {
        state.proximasEntregas = payload
    },
    UPDATE_LOADING_PROXIMAS_ENTREGAS(state, payload) {
        state.loadingProximasEntregas = payload
    },
    UPDATE_PROXIMAS_ENTREGAS_TIMESTAMP(state, payload) {
        state.proximasEntregasLastFetch = payload
    }
}

const actions = {
    async getTicketChangeHistory({ commit }, payload) {
        try {
            if (!payload || !payload.id) {
                console.warn('⚠️ No se proporcionó un ID válido para obtener el historial')
                commit('UPDATE_TICKET_CHANGE_HISTORY', [])
                return
            }

            const query = encodeURIComponent(`{"where":{"idVenta": ${payload.id}}}`)

            const { data } = await request({
                url: `/api-loopback/ticketChangeHistories?filter=${query}`,
                method: 'GET',
                headers: {
                    'content-type': 'application/json'
                }
            })

            console.log('data--->', data)
            commit('UPDATE_TICKET_CHANGE_HISTORY', data || [])
        } catch (err) {
            console.error('❌ Error al obtener el historial de cambios:', err)
            // Asegurás que al menos el estado quede vacío
            commit('UPDATE_TICKET_CHANGE_HISTORY', [])
        }
    },

    async lsVentasEntregadas({ commit, rootState }, payload) {
        const { idSede } = rootState.users.user

        // Parsear la fecha recibida (formato: "YYYY-MM")
        const [year, month] = payload.date.split('-')
        const dateObj = new Date(parseInt(year), parseInt(month) - 1, 1)

        // Usar date-fns para calcular inicio y fin del mes
        const startDate = startOfMonth(dateObj)
        const endDate = startOfMonth(addMonths(dateObj, 1))

        // Formatear a ISO string
        const startOfMonthISO = format(startDate, "yyyy-MM-dd'T'00:00:00'Z'")
        const startOfNextMonthISO = format(endDate, "yyyy-MM-dd'T'00:00:00'Z'")

        const query = encodeURIComponent(`{"where":{"and":[{"idSede": ${idSede}},{
          "date": {
            "gte": "${startOfMonthISO}",
            "lt": "${startOfNextMonthISO}"
          }
        }]}}`)

        const response = await request({
            url: `/api-loopback/tm_ventas/getVentasByEstado/${payload.idEstado}?filter=${query}`,
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        })
        commit('UPDATE_LISTA_ENTREGAS', response.data)
    },
    async fetchProximasEntregas({ commit, rootState, state }) {
        const now = Date.now()
        const oneHourMs = 60 * 60 * 1000
        
        if (state.proximasEntregasLastFetch && (now - state.proximasEntregasLastFetch) < oneHourMs) {
            return
        }
        
        const { idSede } = rootState.users.user
        commit('UPDATE_LOADING_PROXIMAS_ENTREGAS', true)
        try {
            const { data } = await request({
                url: `/api-loopback/tm_ventas/getProximasEntregas/${idSede}`,
                method: 'GET',
                headers: { 'content-type': 'application/json' }
            })
            commit('UPDATE_PROXIMAS_ENTREGAS', data)
            commit('UPDATE_PROXIMAS_ENTREGAS_TIMESTAMP', now)
        } catch {
            commit('UPDATE_PROXIMAS_ENTREGAS', [])
        } finally {
            commit('UPDATE_LOADING_PROXIMAS_ENTREGAS', false)
        }
    },
    async lsVentaNoFinalizada({ commit, rootState }) {
        const check_in = format(new Date(), 'yyyy-MM-dd')
        const { idSede } = rootState.users.user
        const today = JSON.stringify(format(new Date(), 'yyyy-MM-dd'))

        const query = encodeURIComponent(`{"where":{"and":[{"idSede": ${idSede}},{"check_in": ${today}},{"finalizado": 0},{"status": 1}]}}`)
        //console.time('lsVentaNoFinalizada')
        const { data: response } = await request({
            url: `/api-loopback/tm_ventas/getVentasByDate/${idSede}/${check_in}/0/1`,
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        })

        //console.timeEnd('lsVentaNoFinalizada')

        //console.log('result---> ', response)
        const listaMixtos = []
        const listaPrivados = []
        const listaMasajes = []
        const listaProductos = []

        response.map((item) => {
            // //////console.log("here-item")
            // //////console.log(item)
            const mixtos = item.mixtos ? JSON.parse(item.mixtos) : []
            const privados = item.privados ? JSON.parse(item.privados) : []
            const masajes = item.masajes ? JSON.parse(item.masajes) : []
            const productos = item.productos ? JSON.parse(item.productos) : []

            const defaultService = {
                id_reserva: item.id,
                idTipoVenta: item.idTipoVenta,
                full_name: item.full_name
            }

            mixtos.map((val) =>
                listaMixtos.push({
                    ...val,
                    ...defaultService
                })
            )
            privados.map((val) =>
                listaPrivados.push({
                    ...val,
                    ...defaultService
                })
            )
            masajes.map((val) =>
                listaMasajes.push({
                    ...val,
                    ...defaultService
                })
            )
            productos.map((val) =>
                listaProductos.push({
                    ...val,
                    ...val,
                    ...defaultService
                })
            )
        })
        commit('UPDATE_MIXTOS_TODAY', listaMixtos)
        commit('UPDATE_PRIVADOS_TODAY', listaPrivados)
        commit('UPDATE_MASAJES_TODAY', listaMasajes)
        commit('UPDATE_PRODUCTOS_TODAY', listaProductos)
    },
    async postInitVenta({ state, commit, rootState }, payload) {
        const { idSede, idBussines, id } = rootState.users.user
        console.log('rootState.users.user------------------', rootState.users.user)
        const data = new Ventas(state.datos)
        console.log('REQ', data)
        const response = await request({
            url: `/api-loopback/tm_ventas`,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data: {
                ...data,
                idSede,
                idEstado: 33, //new
                idBussines,
                idUserAssignment: data.idUserAssignment ? data.idUserAssignment : id
            }
        })
        //console.log('creating_basic_venta_', response.data)
        commit('UPDATE_DATOS', { ...response.data })
    },

    async patchVenta({ state, commit, rootState }, payload) {
        const {
            id,
            idEstado,
            atributos,
            numeroComprobante,
            numeroGuiaRemision,
            observation,
            idColaborador,
            idUserAssignment,
            check_in,
            direccion,
            referencia,
            celularContacto,
            googleMaps,
            agenciaEnvio,
            formaEntrega,
            tipoEntrega,
            montoDelivery,
            formaPago,
            destinoFinal,
            estadoDeuda,
            ubigeo
        } = payload

        const safePatch = {
            ...(idEstado !== undefined ? { idEstado } : {}),
            ...(atributos !== undefined ? { atributos } : {}),
            ...(numeroComprobante !== undefined ? { numeroComprobante: normalizarComprobante(numeroComprobante) } : {}),
            ...(numeroGuiaRemision !== undefined ? { numeroGuiaRemision } : {}),
            ...(observation !== undefined ? { observation } : {}),
            ...(idColaborador !== undefined ? { idColaborador } : {}),
            ...(idUserAssignment !== undefined ? { idUserAssignment } : {}),
            ...(check_in !== undefined ? { check_in } : {}),
            ...(direccion !== undefined ? { direccion } : {}),
            ...(referencia !== undefined ? { referencia } : {}),
            ...(celularContacto !== undefined ? { celularContacto } : {}),
            ...(googleMaps !== undefined ? { googleMaps } : {}),
            ...(agenciaEnvio !== undefined ? { agenciaEnvio } : {}),
            ...(formaEntrega !== undefined ? { formaEntrega } : {}),
            ...(tipoEntrega !== undefined ? { tipoEntrega } : {}),
            ...(montoDelivery !== undefined ? { montoDelivery } : {}),
            ...(formaPago !== undefined ? { formaPago } : {}),
            ...(destinoFinal !== undefined ? { destinoFinal } : {}),
            ...(estadoDeuda !== undefined ? { estadoDeuda } : {}),
            ...(ubigeo !== undefined ? { ubigeo } : {})
        }

        await request({
            url: `/api-loopback/tm_ventas/${payload.id}`,
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            data: safePatch
        })
        //console.log("data---",data)
    },
    async CrearCitaOrdenCompra({ state, commit, rootState }, payload) {
        console.log('paylaod--', payload)
        await request({
            url: '/api-orquestador/v2.0/cron/generarCita',
            //url: 'http://localhost:3000/orq/v2.0/cron/generarCita',
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data: payload
        })
    },
    async enviarComprobante({ commit }, payload) {
        const { clientEmail, fechaFacturacion, isEmailSelected, _full_name, documento } = payload
        const comprobante = documento.find((v) => v.id == isEmailSelected)
        const { fileName, url } = comprobante
        if (clientEmail) {
            const { data } = await request({
                url: '/api-orquestador/email/v2.0/Comprobante',
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                data: {
                    email: clientEmail,
                    asunto: 'ENVIO DEL COMPROBANTE',
                    parametros: {
                        Tipo_Envio: isEmailSelected,
                        full_name: _full_name,
                        serviceId: 3,
                        archivosAdjuntos: '',
                        fechaCreacion: fechaFacturacion,
                        url: url,
                        fileName: `${fileName}.pdf`
                    }
                }
            })
            console.log('response', data)
            return data
        }
    },

    async comprobante({ state, commit, rootState }, data) {
        console.log('data', data)
        const response = await request({
            //url: `http://localhost:3000/ms/migraciones/v1.0/comprobante/emitir`,
            url: `/ms/migraciones/v1.0/comprobante/emitir`,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data
        })
        console.log('response', response.data)
        return response
    },
    // Anticipos pendientes de una venta, leidos de facturación (fuente real): cubre los
    // emitidos desde la intranet y los emitidos desde la UI de facturación.
    async anticiposPendientes({ rootState }, payload) {
        const { data } = await request({
            url: `/ms/migraciones/v1.0/anticipos/pendientes`,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data: {
                idSede: Number(rootState.users.user.idSede),
                idVenta: Number(payload.id)
            }
        })
        return (data && data.data) || []
    },
    async obtenerVenta({ state, commit, rootState }, payload) {
        //console.log('result', payload)

        const { data } = await request({
            url: `/ms/inventario/private/1.0/obtener/venta`,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data: {
                idVenta: Number(payload.id)
            }
        })
        //console.log('creating_basic_venta_', data)
        return data.data
    },

    async obtenerProducto({ state, commit, rootState }, payload) {
        // Sin id de producto o sin sede no hay request posible: antes se enviaba
        // `?id=undefined&idSede=undefined` y el backend ya no la acepta (400).
        // La sede se toma del usuario logueado cuando el llamador no la pasa.
        const params = buildObtenerProductoParams(payload, rootState?.users?.user?.idSede)
        if (!params) {
            console.warn('obtenerProducto: faltan id o idSede, no se consulta el producto', payload)
            return null
        }

        const { data } = await request({
            url: `/ms/migraciones/v1.0/items`,
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            },
            params
        })
        //console.log('obtenerProducto', data)
        return data
    },
    async ventaProducto({ state, commit, rootState }, payload) {
        const { data } = await request({
            url: `api-loopback/tm_ventas/${payload.id}`,
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        })
        //console.log('ventaProducto', data)
        return data
    },
    async crearOrdenPedido({ state, commit, rootState }, payload) {
        //console.log('result obtenerProducto', payload)
        const { vendedor, personalCargo, fechaEmision, ordenPedido, producto, color, medida, material, observaciones, cantidad } = payload

        const { data } = await request({
            url: `/ms/inventario/private/1.0/agregar/orden/Produccion`,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data: {
                vendedor,
                personalCargo,
                fechaEmision,
                ordenPedido: ordenPedido ? ordenPedido : null,
                producto,
                color: color ? color : 'NO DEFINIDO',
                medida: medida ? medida : 'NO DEFINIDO',
                material,
                observaciones,
                cantidad: cantidad || 1
            }
        })
        //console.log('creating_basic_venta_', data)
        return data
    },
    async crearOrdenEquipamiento({ state, commit, rootState }, payload) {
        //console.log('result obtenerProductoOE', payload)
        const { vendedor, personalCargo, fechaEmision, ordenPedido, producto, model, medida, color, posicion, observaciones, items, tipoEquipamiento, plantillaId } = payload
        const { data } = await request({
            url: `/ms/inventario/private/1.0/agregar/orden/Equipamiento`,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data: {
                vendedor,
                personalCargo,
                fechaEmision,
                ordenPedido: ordenPedido ? ordenPedido : 0,
                producto,
                modelo: model ? model : 'NO DEFINIDO',
                medida: medida ? medida : 'NO DEFINIDO',
                color: color ? color : 'NO DEFINIDO',
                posicion,
                observaciones,
                items,
                tipoEquipamiento: tipoEquipamiento || null,
                plantillaId: plantillaId || null
            }
        })
        //console.log('creating_basic_venta_', data)
        return data
    },
    async postVenta({ state, rootState }, payload) {
        // //console.log("POST RESERVAS");
        const { mixtos, privados, masajes, productos, cortesia } = state
        //const importeTotal = GET_IMPORTE_TOTAL(mixtos, privados, masajes, productos);
        const data = {
            ...state.datos,
            idSede: rootState.users.user.idSede,
            idColaborador: rootState.users.user.id,
            finalizado: payload.estado,
            idEstado: payload.estado ? 34 : 33,
            mixtos,
            privados,
            masajes,
            productos,
            cortesia
        }
        //33 -- nuevo
        //34 -- finalizado
        //console.log('INPUT : ', data)
        const response = await request({
            url: `/api-orquestador/ventas/v2.0/kunte`,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data
        })
        //console.log('output: ', response.data)
        return response.data
        // //////console.log(response.data)
    },
    async obtenerDataVenta({ state, rootState }, payload) {
        const response = await request({
            url: `/api-orquestador/ventas/v2.0/kunte`,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data
        })
        //console.log('output: ', response.data)
        return response.data
    },
    async obtenerDataVenta({ state, rootState }, payload) {},
    async deleteVenta({}, payload) {
        /*     //console.log(payload.idTipoVenta) */
        const { idTipoVenta } = payload
        /* //console.log(api) */
        const response = await request({
            url: `/api-loopback/tm_ventas/${payload.id}`,

            method: 'DELETE',
            headers: {
                'content-type': 'application/json'
            }
        })
        //console.log(response.data)
        return response.data
    },
    async assignmentVenta({}, payload) {
        console.log('payload', payload)
        await request({
            url: `/api-loopback/tm_ventas/${payload.idVenta}`,
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            data: {
                idUserAssignment: payload.idUsuario,
                idSede: payload.data.idSede
            }
        })
    },
    async selectReserva({ commit, rootGetters, rootState }, payload) {
        console.log('payload_edit', payload)
        const { idSede } = rootState.users.user

        const response = await request({
            url: `/api-loopback/tm_ventas/${payload.id}`,
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        })
        const item = response.data
        console.log('item ', item)

        let findCliente = null
        if (item.idCliente) {
            try {
                const { data: clienteResp } = await request({
                    url: `/ms/migraciones/v2.0/persons/${item.idCliente}?idSede=${idSede}`,
                    method: 'GET',
                    headers: { 'content-type': 'application/json' }
                })
                if (clienteResp.codigoRespuesta === '00') {
                    findCliente = {
                        ...clienteResp.data,
                        defaultName: clienteResp.data.name
                    }
                }
            } catch (e) {
                console.warn('No se pudo obtener cliente por id:', e.message)
            }
        }
        console.log('------>findCliente', findCliente)

        let _item = {
            ...item,
            atributos: item.atributos ? item.atributos : DefaultForm.formAttributes(),
            numeroDocumento: findCliente ? findCliente.number : null,
            emailClient: findCliente ? findCliente.email : null,
            phoneClient: findCliente ? findCliente.telephone : null,
            full_name: findCliente ? findCliente.defaultName : null,
            idTipoDocumento: findCliente ? findCliente.identity_document_type_id : null,
            formaPago: Number(item.formaPago)
        }
        console.log('items', _item)

        commit('RESET_DATOS')
        commit('UPDATE_IDVENTA', payload.id)
        commit('UPDATE_MIXTOS', typeof item.mixtos === 'string' ? JSON.parse(item.mixtos || '[]') : (item.mixtos || []))
        commit('UPDATE_PRIVADOS', typeof item.privados === 'string' ? JSON.parse(item.privados || '[]') : (item.privados || []))
        commit('UPDATE_MASAJES', typeof item.masajes === 'string' ? JSON.parse(item.masajes || '[]') : (item.masajes || []))
        commit('UPDATE_PRODUCTOS', typeof item.productos === 'string' ? JSON.parse(item.productos || '[]') : (item.productos || []))
        commit('UPDATE_DATOS', _item)
    },
    // async getLastCodeBar({ commit }, payload) {
    //     const { data } = await request({
    //         url: `/ms/inventario/private/1.0/get/barcode`,
    //         method: 'POST',
    //         headers: {
    //             'content-type': 'application/json'
    //         },
    //         data: {
    //             idVenta: payload.id
    //         }
    //     })
    //     // //console.log("get_reserva");
    //     commit('UPDATE_MYCODEBAR', data)
    // },
    async activarTicket({ commit }, payload) {
        //console.log('payload', payload)
        const { data } = await request({
            url: `/api-loopback/tm_ventas/${payload.id}`,
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            data: {
                finalizado: 0
            }
        })
    },
    async updateReserva({ rootState, dispatch, commit, state }, payload) {
        // //console.log("UPDATE_RESERVAS");
        const { mixtos, privados, masajes, productos, cortesia, datos } = state
        const { idTipoVenta, efectivo, transferencia, tarjeta } = datos
        // //console.log('idTipoVenta ', idTipoVenta)
        const importeTotal = GET_IMPORTE_TOTAL(mixtos, privados, masajes, productos)
        const importeAbonado = SUMA_TOTAL(efectivo, tarjeta, transferencia)
        console.log('payload', payload)
        let data = {
            ...datos,
            // Un montoFacturacion en 0 congelaba la emisión en S/ 0: se guarda
            // null para que el diálogo siga cayendo a importeTotal.
            ...(datos.montoFacturacion !== undefined ? { montoFacturacion: montoParaGuardar(datos.montoFacturacion) } : {}),
            // El número de comprobante se guarda limpio (SERIE-NUMERO): el sync
            // de pagos lo busca así y con anotaciones no lo encuentra.
            ...(datos.numeroComprobante !== undefined ? { numeroComprobante: normalizarComprobante(datos.numeroComprobante) } : {}),
            status: 1,
            importeTotal,
            importeAbonado,
            mixtos: state.mixtos,
            privados: state.privados,
            masajes: state.masajes,
            productos: state.productos,
            id_reserva: payload.id,
            finalizado: payload.estado,
            idUsuarioModificador: rootState.users.user.id,
            atributos: {
                ...datos.atributos
            }
            // nroOperacion:payload.
        }
        // //console.log("body");
        if (payload.estado == 1 && datos.idBussines == 1) {
            data.idEstado = 34
        } else {
            delete data.idEstado
        }

        console.log('data---', data)
        /* updateReserva */
        const response = await request({
            url: `/api-loopback/tm_ventas/${payload.id}`,
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            data
        })
        console.log('response.data ', response.data)
        commit('UPDATE_DATOS', { ...response.data })
        return response.data
    },
    async getReservas({ commit, rootState }, { firstDay, nextDay, tipoFiltro }) {
        commit('UPDATE_LOADING_RESERVAS', true)
        const { idSede, id_role, idBussines } = rootState.users.user
        const _nextDay = nextDay || formatInTimeZone(addMonths(new Date(), 1), 'America/Lima', 'yyyy-MM-dd')
        const _firstDay = firstDay || formatInTimeZone(subMonths(new Date(), 2), 'America/Lima', 'yyyy-MM-dd')
        const _tipoFiltro = [2, 3, 4].includes(id_role) ? 5 : tipoFiltro || 3

        const { data: result } = await request({
            url: `/ms/migraciones/v3.0/ventas`,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data: {
                idSede: String(idSede),
                _firstDay: String(_firstDay),
                _nextDay: String(_nextDay),
                _tipoFiltro: String(_tipoFiltro),
                idBussines: Number(idBussines),
                id_role: id_role,
                finalizado: 3
            }
        })

        let items = result.data
        console.log('items V1 (sin filtrar)', items)
        console.log('id_role', id_role)

        // Aplicar filtro según el rol (configuración única compartida)
        const configuracionRol = FILTROS_ROL[id_role]

        if (configuracionRol) {
            console.log(`Aplicando filtro para rol: ${configuracionRol.nombre}`)
            items = items.filter((venta) => pasarFiltroRol(venta, configuracionRol))
            console.log(`Total ventas visibles: ${items.length}`)
        } else {
            console.warn(`No hay configuración de filtro para id_role: ${id_role}`)
        }

        console.log('items V2 (filtrados por rol)', items)

        commit('UPDATE_LISTA_RESERVAS', items)
        commit('UPDATE_LOADING_RESERVAS', false)
        return items
    },
    async getReservasV2({ commit, rootState }, payload) {
        commit('UPDATE_LOADING_RESERVAS', true)
        const { idSede, id_role, idBussines } = rootState.users.user
        const effectiveTipoFiltro = [2, 3, 4].includes(id_role) ? 5 : payload.tipoFiltro ?? 3

        const { data } = await request({
            url: `/ms/migraciones/v4.0/ventas/reservas`,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data: {
                idSede: String(idSede),
                fechaInicio: payload.fechaInicio,
                fechaFin: payload.fechaFin,
                idBussines: Number(idBussines),
                id_role: id_role,
                finalizado: payload.finalizado ?? 3,
                tipoFiltro: effectiveTipoFiltro,
                skip: payload.skip || 0,
                limit: payload.limit !== undefined ? payload.limit : 20,
                idVenta: payload.idVenta || undefined,
                numeroDocumento: payload.numeroDocumento || undefined,
                nombreCliente: payload.nombreCliente || undefined,
                idOrdenCompra: payload.idOrdenCompra || undefined,
                descripcion: payload.descripcion || undefined,
                idEstado: payload.idEstado || undefined,
                idCotizacion: payload.idCotizacion || undefined,
                numeroComprobante: payload.numeroComprobante || undefined,
                web_online: payload.web_online || undefined
            }
        })

        let items = data.data
        const configuracionRol = FILTROS_ROL[id_role]
        if (configuracionRol) {
            items = items.filter((venta) => pasarFiltroRol(venta, configuracionRol))
        }

        commit('UPDATE_LISTA_RESERVAS', items)
        commit('UPDATE_LOADING_RESERVAS', false)
        return { data: items, total: data.total }
    },
    async getReservasCalendario({ commit, rootState }, { firstDay, nextDay, tipoFiltro }) {
        commit('UPDATE_LOADING_RESERVAS', true)
        const { idSede, id_role, idBussines } = rootState.users.user
        const _nextDay = nextDay || formatInTimeZone(addMonths(new Date(), 1), 'America/Lima', 'yyyy-MM-dd')
        const _firstDay = firstDay || formatInTimeZone(subMonths(new Date(), 2), 'America/Lima', 'yyyy-MM-dd')
        const _tipoFiltro = [2, 3, 4].includes(id_role) ? 5 : tipoFiltro || 3

        const { data: result } = await request({
            url: `/ms/migraciones/v2.0/ventas/calendario`,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data: {
                idSede: String(idSede),
                _firstDay: String(_firstDay),
                _nextDay: String(_nextDay),
                _tipoFiltro: String(_tipoFiltro),
                idBussines: Number(idBussines)
            }
        })

        let items = result.data
        console.log('items V1 (sin filtrar)', items.length)

        // Estados permitidos en el CALENDARIO
        const estadosCalendario = [
            33, // NUEVO
            32, // LARGO PLAZO
            17, // EN STOCK TIENDA
            21, // EN STOCK TALLER 1
            22, // EN STOCK ALMACÉN
            24, // STOCK CHILLON
            37, // STOCK VILLA MARIA
            46, // STOCK CHICLAYO
            12, // PREPARANDO
            1, // FABRICACIÓN
            30, // REVISION TEC.
            29, // PROCESANDO
            36, // PENDIENTE DE PLANO
            3, // ACABADOS
            23, // DESMOLDE
            2, // EQUIPAMIENTO
            4, // SOLICITADO
            5, // EMBALAJE
            6, // TERMINADO
            7, // PROGRAMADO
            27, // CARGA OK EOT
            25, // CARGA OK ASN
            26, // CARGA OK ERC
            31, // RECOLECCION CONFIRMADA
            8, // EN CAMINO
            15, // ENTREGA PARCIAL
            38, // LOGISTICA INVERSA
            28 // ENTREGADO CON PROCESO DE DEVOLUCION
        ]

        // Filtrar solo estados del calendario y no finalizados
        items = items.filter((venta) => {
            return estadosCalendario.includes(venta.idEstado) && venta.finalizado !== 1
        })

        console.log('items V2 (filtrados para calendario)', items.length)
        commit('UPDATE_LOADING_RESERVAS', false)

        return items
    },
    async getReservasToday({ commit, rootState }, payload) {
        const { idSede } = rootState.users.user
        const { today } = payload
        const query = encodeURIComponent(`{"where":{"and":[{"idSede": ${idSede}},{"check_in": ${today}}]}}`)
        //console.log('query')
        //console.log(query)
        const response = await request({
            url: `/api-loopback/tm_ventas?filter=${query}`,
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        })
        //console.log(response.data)
        commit('UPDATE_LISTA_RESERVAS_TODAY', response.data)
        return response.data
    },
    async getPendientesReservas({ commit, rootState }) {
        const { idSede } = rootState.users.user
        const today = JSON.stringify(format(subDays(new Date(), 1), 'yyyy-MM-dd'))
        const query = encodeURIComponent(`{"where":{"and":[{"idSede": ${idSede}},{"check_in": {"gt":${today}}}]}}`)

        //console.log('query')
        //console.log(query)
        const response = await request({
            url: `/api-loopback/tm_ventas?filter=${query}`,
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        })
        //console.log('getPendientesReservas', response.data)
        let items = []
        response.data.map((x) => items.push({ ...x, importePendiente: x.importeTotal - x.adelanto }))
        commit('UPDATE_LISTA_RESERVAS_PENDIENTES', items)
        return items
    },
    async traerOrdenesEquipamiento({ commit, rootState }, payload) {
        //console.log('payloadequipamiento', payload)
        let ordenEquipamiento = []
        const { data } = await request({
            url: `/ms/inventario/private/1.0/traer/orden/equipamiento`,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data: {
                id: payload.id
            }
        })

        // Find ordenPedido safely - handle case where it might be 0 or undefined
        const ordenConPedido = data.data.find((x) => x.ordenPedido && x.ordenPedido > 0)
        const idVenta = ordenConPedido ? ordenConPedido.ordenPedido : 0

        let prods = []
        if (idVenta && idVenta > 0) {
            try {
                const response = await request({
                    url: `/api-loopback/tm_ventas/${idVenta}`,
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                })
                if (response.data && response.data.productos && Array.isArray(response.data.productos)) {
                    for (let i = 1; i < response.data.productos.length; i++) {
                        prods.push(response.data.productos[i])
                    }
                }
            } catch (error) {
                console.warn('No se pudo obtener productos de tm_ventas:', error.message)
                // Continuar sin productos fallback
            }
        }

        data.data.forEach((x) => {
            // Parse items if they come as JSON string, otherwise use items from the API response
            const parsedItems = x.items ? (typeof x.items === 'string' ? JSON.parse(x.items) : x.items) : prods
            ordenEquipamiento.push({ ...x, items: parsedItems })
        })
        return ordenEquipamiento
    },
    async delReserva({}, payload) {
        // ////console.log(payload);
        const response = await request({
            url: `/api-loopback/tm_ventas/${payload.id}`,

            method: 'DELETE',
            headers: {
                'content-type': 'application/json'
            }
        })
        // //////console.log(response.data);
        return response.data
    },
    async getVentasByMes({ commit, rootState }, payload) {
        const { data } = await request({
            url: `/api-loopback/tm_ventas/getVentasByMes/${payload.idSede}/${payload.fecha}`,
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        })

        //console.log('PRE-RESERVAS----->', data)
        return data

        //commit('UPDATE_LISTA_RESERVAS', result)
    },

    /**
     * Verificar si una venta ya fue copiada a Cuba
     */
    async verificarCopiaCuba({}, ventaId) {
        const response = await request({
            url: `/api-loopback/tm_ventas/yaCopiadoACuba/${ventaId}`,
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        })
        return response.data
    },

    /**
     * Copiar una venta de Kunte a Cuba
     * @param {number} id - ID de la venta original
     * @param {number} diasAnticipacion - Días de anticipación para la fecha de entrega en Cuba
     * @returns {object} Resultado de la operación
     */
    async copiarVentaACuba({}, payload) {
        const { id, diasAnticipacion, descuentoPorcentaje } = payload

        const response = await request({
            url: `/api-loopback/tm_ventas/copiarACuba/${id}`,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data: { diasAnticipacion, descuentoPorcentaje }
        })
        return response.data
    },

    async getVentasByMonth({ commit, rootState }, payload) {
        const { date, idColaborador } = payload
        let fechaInicial, fechaFinal
        console.log('date', date)
        console.log('length', date.length)
        if (date.length === 7) {
            // Si la variable es un mes
            fechaInicial = `${date}-01T00:00:00.000`
            fechaFinal = `${date}-31T23:59:59.999`
        } else {
            // Si la variable es una fecha completa
            fechaInicial = `${date}T00:00:00.000`
            fechaFinal = `${date}T23:59:59.999`
        }

        console.log('fechaFinal', fechaFinal)
        const filter = {
            where: {
                and: [
                    {
                        created_at: { between: [fechaInicial, fechaFinal] }
                    },
                    {
                        idColaborador: idColaborador
                    },
                    {
                        status: 1
                    },
                    {
                        idEstado: { neq: 11 }
                    }
                ]
            }
        }
        console.log('url', `/api-loopback/tm_ventas?filter=${JSON.stringify(filter)}`)

        const { data } = await request({
            url: `/api-loopback/tm_ventas?filter=${JSON.stringify(filter)}`,
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        })
        return data
    }
}

const getSubTotal = (item) => {
    try {
        if (item.length > 0) {
            let suma = 0
            item.map((val) => {
                suma += parseFloat(val.subTotal)
            })
            return suma
        }
        return 0
    } catch (error) {
        return 0
    }
}

const GET_IMPORTE_TOTAL = (a, b, c, d) => {
    return getSubTotal(a) + getSubTotal(b) + getSubTotal(c) + getSubTotal(d)
}

const SUMA_TOTAL = (a, b, c) => {
    return parseFloat(a) + parseFloat(b) + parseFloat(c)
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
